export function openGenericModal(content: string, heading: string) {
    const dialog = document.getElementById("generic-dialog")

    if (dialog === null) {
        const dialog = document.createElement("lds-dialog")
        dialog.id = "generic-dialog"
        dialog.style.width = "50%"
        dialog.style.display = "block"

        const modalContainer = document.createElement("div")
        modalContainer.classList.add("generic-dialog-modal", "modal", "in")
        modalContainer.id = "generic-dialog-modal"
        modalContainer.tabIndex = Number("-1")
        modalContainer.setAttribute("role", "dialog")
        modalContainer.setAttribute("aria-label", heading)
        modalContainer.setAttribute("data-backdrop", "static")
        modalContainer.style.display = "block"
        modalContainer.style.paddingRight = "14px"

        const modalDialog = document.createElement("div")
        modalDialog.classList.add("modal-dialog")
        modalDialog.setAttribute("role", "document")

        const modalContent = document.createElement("div")
        modalContent.classList.add("modal-content")

        const modalHeader = document.createElement("header")
        modalHeader.classList.add("modal-header")

        const closeButtonContainer = document.createElement("div")
        closeButtonContainer.classList.add("p-15-t", "icon-modal-close", "pull-right")
        closeButtonContainer.setAttribute("data-dismiss", "modal")
        closeButtonContainer.setAttribute("title", "Schließen")

        const closeButtonIcon = document.createElement("span")
        closeButtonIcon.classList.add("icon", "gray", "block", "icon-16")

        const closeButtonSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg")
        closeButtonSvg.classList.add("icon")
        closeButtonSvg.setAttribute("data-action", "close")

        const useElement = document.createElement("use")
        useElement.setAttribute("href", "/ladies/images/icon-defs.svg?v1.0#icon-cross-thin")

        closeButtonSvg.appendChild(useElement)
        closeButtonIcon.appendChild(closeButtonSvg)
        closeButtonContainer.appendChild(closeButtonIcon)

        const modalTitle = document.createElement("div")
        modalTitle.classList.add("generic-dialog-modal-heading", "modal-title")
        modalTitle.id = "generic-dialog-modal-heading"
        modalTitle.innerHTML = heading

        modalHeader.appendChild(closeButtonContainer)
        modalHeader.appendChild(modalTitle)

        const modalBody = document.createElement("section")
        modalBody.classList.add("modal-body")

        const modalBodyContent = document.createElement("div")
        modalBodyContent.classList.add("generic-dialog-modal-content")
        modalBodyContent.id = "generic-dialog-modal-content"
        modalBodyContent.innerHTML = content

        const modalBodyButtonContainer = document.createElement("div")
        modalBodyButtonContainer.classList.add("col-xs-8", "col-xs-offset-2", "m-15-b")

        const closeButton = document.createElement("button")
        closeButton.setAttribute("id", "generic-dialog-close-button")
        closeButton.setAttribute("data-dismiss", "modal")
        closeButton.classList.add("btn-lg", "btn-block", "btn-rounded", "btn-white")
        closeButton.textContent = "Schließen"

        modalBody.appendChild(modalBodyContent)
        modalBodyButtonContainer.appendChild(closeButton)
        modalBody.appendChild(modalBodyButtonContainer)
        modalContent.appendChild(modalHeader)
        modalContent.appendChild(modalBody)
        modalDialog.appendChild(modalContent)
        modalContainer.appendChild(modalDialog)

        dialog.appendChild(modalContainer)

        document.body.appendChild(dialog)

        return dialog
    }

    const genericDialogModalHeading = document.getElementById("generic-dialog-modal-heading")
    const genericDialogModalContent = document.getElementById("generic-dialog-modal-content")

    if (genericDialogModalHeading !== null) {
        genericDialogModalHeading.innerHTML = heading
    }

    if (genericDialogModalContent !== null) {
        genericDialogModalContent.innerHTML = content
    }

    dialog.style.display = "block"
    return dialog
}

if ("" !== location.hash.replace("#", "")) {
    const hashtagParams = new URLSearchParams(location.hash.replace(/^#/, ""))

    for (const modalName of hashtagParams.keys()) {
        if (modalName === "banner-free-modal" && userData.hasAdFree) {
            continue
        }
        requestAnimationFrame(() => {
            $(`#${modalName}`).modal("show")
        })
    }
}
